import { createContext, useContext, useEffect, useState } from "react";
import { api, errText } from "../lib/api";
import { toast } from "sonner";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/customer/me");
      setCustomer(data);
    } catch { setCustomer(false); }
    finally { setLoading(false); }
  };
  useEffect(() => {
    // iter135 — OAuth callback fragment varsa /me check'ini atla, AuthCallback halleder
    if (typeof window !== "undefined" && window.location.hash.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/customer/login", { email, password });
      if (data.token) localStorage.setItem("token", data.token);
      await refresh();
      toast.success("Giriş başarılı");
      return true;
    } catch (e) { toast.error(errText(e)); return false; }
  };

  const register = async (name, email, password, phone) => {
    try {
      const { data } = await api.post("/customer/register", { name, email, password, phone });
      if (data.token) localStorage.setItem("token", data.token);
      await refresh();
      toast.success("Hesabınız oluşturuldu");
      return true;
    } catch (e) { toast.error(errText(e)); return false; }
  };

  // iter135 — Emergent Google Auth
  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    localStorage.removeItem("token");
    setCustomer(false);
  };

  return <CustomerAuthContext.Provider value={{ customer, loading, login, register, loginWithGoogle, logout, refresh }}>{children}</CustomerAuthContext.Provider>;
};
export const useCustomerAuth = () => useContext(CustomerAuthContext);
